import {
  Button,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import useNotification from '../../../../hooks/useNotification';
import { postTCDetails } from '../../../../features/student/studentSlice';
import api from '../../../../services/api';
import ToastNotification from '../../../UIElements/ToastNotification';
import { getClasses } from '../../../../features/classes/ClassSlice';
import { TCIdCheck } from '../../../../features/history/HistorySlice';
const initialData = {
  tcNumber: '',
  collegeName: '',
  location: '',
  studentName: '',
  studentId: '',
  rollNo: '',
  dob: '',
  guardianName: '',
  religion: '',
  category: '',
  leavingClass: '',
  firstLanguage: '',
  secondLanguage: '',
  optionalSubject: '',
  medium: '',
  firstAdmissionClass: '',
  dateOfJoining: '',
  qualified: '',
  eligible: '',
  scholarship: '',
  concession: '',
  mole1: '',
  mole2: '',
  leavingDate: '',
  tcDate: '',
  conduct: '',
  signature: '',
};
export const ValidationSchema = Yup.object({
  tcNumber: Yup.number(),
  studentId: Yup.string().required('Student ID is required'),
  rollNo: Yup.number().required('Roll No is required'),

  collegeName: Yup.string().required('College name is required'),
  studentName: Yup.string().required('Student name is required'),
  guardianName: Yup.string().required('Guardian Name is required'),
  religion: Yup.string().required('Religion is required'),
  category: Yup.string().required('Category is required'),

  dob: Yup.string().required('Date of Birth is required'),
  leavingClass: Yup.string().required('Leaving class is required'),
  firstLanguage: Yup.string().required('First language is required'),
  secondLanguage: Yup.string().required('Second language is required'),
  optionalSubject: Yup.string(),

  medium: Yup.string().required('Mother Tongue and Medium are required'),
  dateOfJoining: Yup.string().required('Date of Joining is required'),
  firstAdmissionClass: Yup.string().required(
    'First Admission Class is required',
  ),
  qualified: Yup.boolean().required('Required'),
  eligible: Yup.boolean().required('Required'),
  scholarship: Yup.boolean().required('Required'),

  concession: Yup.string().required('Concession field is required'),
  leavingDate: Yup.string().required('Leaving date is required'),
  tcDate: Yup.string().required('TC date is required'),
  conduct: Yup.string(),
});
export default function VeerisettyCollegeEmptyTC({ StudentId = 'STU88' }) {
  const dispatch = useDispatch();
  const [studentId, setStudentId] = useState('');
  const [data, setData] = useState({ ...initialData });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isIdExists, setIsIdExists] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [classNames, setClassNames] = useState([]);
  const { notification, showSuccess, showError, hideNotification } =
    useNotification();
  const userDetails = useSelector(
    (state) => state?.auth?.successData?.userDetails,
  );
  async function downloadTC(searchParameters) {
    try {
      setIsDownloading(true);
      const fileResponse = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `tc/download/${studentId}`,
        method: 'GET',
        responseType: 'blob',
        headers: searchParameters,
      });
      const blob = new Blob([fileResponse?.data], {
        type: fileResponse.headers['content-type'],
      });

      let filename = `${studentId}-TC.pdf`;
      const contentDisposition = fileResponse?.headers['content-disposition'];
      const match = contentDisposition?.match(/filename="?(.+)"?/);

      if (match?.[1]) filename = match[1];

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      showError('Error in Downloading the TC.');
      console.error('Download failed', err);
    } finally {
      setIsDownloading(false);
    }
  }
  async function retriveClasses() {
    try {
      const res = await dispatch(getClasses()).unwrap();
      const departmentNames = res.map((item) => ({
        label: item?.department,
        value: item?.department,
      }));
      setClassNames(departmentNames);
    } catch (error) {
      showError('Error in getting class details.');
    }
  }
  useEffect(() => {
    setStudentId(StudentId);
    if (classNames?.length == 0) retriveClasses();
    setData({
      ...data,
      collegeName: userDetails?.instituteName ?? '',
      location: userDetails?.location ?? '',
    });
  }, [StudentId]);

  return (
    <div>
      <Formik
        initialValues={data}
        validationSchema={ValidationSchema}
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={async (values) => {
          try {
            setIsSubmitting(true);
            const resp = await dispatch(postTCDetails(values)).unwrap();
            if (resp.status === 200) {
              setStudentId(resp.data.studentId);
              setData(resp.data);
              showSuccess('TC details submitted successfully.');
            }
          } catch (error) {
            console.log(error);
            showError('Error in submitting the TC details.');
          } finally {
            setIsSubmitting(false);
          }
        }}
      >
        {({ values }) => (
          <Form>
            <div className=' bg-[#fffffa] relative  mx-auto  border p-8 rounded'>
              {/* TOP */}
              {(isSubmitting || isDownloading) && (
                <div className='absolute inset-0 z-10 flex items-center justify-center bg-white/80 opacity-80'>
                  <span className='text-lg font-semibold '>
                    {isSubmitting ? 'Submitting...' : 'Downloading...'}
                  </span>
                </div>
              )}
              <div className='flex justify-between mb-3 flex-wrap gap-2'>
                {/* TC Number */}
                <div>
                  Transfer Certificate No :{' '}
                  {data?.tcNumber ? (
                    <b className='text-red-500'> {data?.tcNumber}</b>
                  ) : (
                    <small className='text-sm text-red-600'>
                      Generates automatically
                    </small>
                  )}
                </div>
                {/* Adsmission Number */}
                <div>
                  <div className='flex gap-2 mr-2'>
                    <span className='text-nowrap'>Admission No :</span>{' '}
                    <Field name='studentId'>
                      {({ field, meta }) => (
                        <TextField
                          size='small'
                          className='w-40'
                          variant='standard'
                          {...field} // Spreads name, value, onChange, and onBlur
                          fullWidth
                          // Error handling:
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                          onChange={(e) => {
                            field.onChange(e);
                            const value = e.target.value;
                            if (!value) setIsIdExists(false);
                          }}
                          onBlur={async (e) => {
                            field.onBlur(e);
                            if (e.target.value) {
                              const res = await dispatch(
                                TCIdCheck(e.target.value),
                              ).unwrap();
                              setIsIdExists(res);
                            } else {
                              setIsIdExists(false);
                            }
                          }}
                        />
                      )}
                    </Field>
                  </div>
                  {isIdExists && (
                    <div
                      id='transactionIdError'
                      className='mb-2 text-red-600 text-sm text-center'
                    >
                      Admission No already Exists
                    </div>
                  )}
                </div>
                {/* Roll No */}
                <div className='flex gap-2'>
                  <span className='text-nowrap'>Roll No :</span>
                  <InputField name='rollNo' className=' w-20' />
                </div>
              </div>
              <h2 className='text-center text-[20px] font-bold mb-4'>
                FORM OF TRANSFER CERTIFICATE OF INTERMEDIATE COURSE
              </h2>
              <div className='space-y-4 text-[16px] mt-4'>
                <FormRow
                  num='1.'
                  label='Name of the College (Place & District)'
                >
                  <div contentEditable>
                    <b>{values?.collegeName?.toUpperCase()}</b>
                    <br />
                    {values?.location}
                  </div>
                </FormRow>

                <FormRow num='2.' label='Name of the Pupil' name='studentName'>
                  {' '}
                  <InputField name='studentName' />
                </FormRow>
                <FormRow
                  num='3.'
                  label='Name of the Parent or Guardian'
                  name='guardianName'
                >
                  {' '}
                  <InputField name='guardianName' />
                </FormRow>
                <FormRow num='4.' label=' Religion' name='religion'>
                  <InputField name='religion' />
                </FormRow>
                <FormRow
                  num='5.'
                  label='Whether the candidate belongs to S.C/ST/BC'
                  name='category'
                >
                  <InputField name='category' />
                </FormRow>
                <FormRow
                  num='6.'
                  label='Date of Birth  as entered in the Admission Register'
                  name='dob'
                >
                  <DateField name='dob' />
                </FormRow>
                {/* 7 */}
                <FormRow
                  num='7.'
                  label='(a) Class in which the pupil was reading at the time of leaving (in words)'
                >
                  <InputField name='leavingClass' />
                </FormRow>
                <FormRow num='' label='(b) First Language under Part - I'>
                  <InputField name='firstLanguage' />
                </FormRow>
                <FormRow num='' label='(c) Second Language under part - II'>
                  <InputField name='secondLanguage' />
                </FormRow>
                <FormRow
                  num=''
                  label='(d) Optionals under Part - III'
                  name='optionals'
                >
                  <InputField name='optionalSubject' />
                </FormRow>
                <FormRow
                  num='8.'
                  label='Mother Tongue and Medium of Instruction'
                >
                  <SelectField
                    name='medium'
                    options={[
                      {
                        label: 'Telugu and English',
                        value: 'Telugu and English',
                      },
                      {
                        label: 'English and English',
                        value: 'English adn English',
                      },
                    ]}
                    placeholder={'Select Mother Tongue and Medium'}
                  />
                </FormRow>
                <FormRow
                  num='9.'
                  label='Date of admission to 1st year Intermediate Course.'
                >
                  <DateField name='dateOfJoining' />
                </FormRow>
                <FormRow
                  num='10.'
                  label='Class  in which the pupil was first admitted into the Intermediate course (Ist year or 2nd year Class)'
                >
                  <InputField name='firstAdmissionClass' />
                </FormRow>
                <FormRow
                  num='11.'
                  label='Whether qualified to study II year class or Intermediate course (in case of students leaving after completing 1st year class)'
                >
                  <SelectField
                    name='qualified'
                    options={booleanValues}
                    placeholder='Select Value'
                  />
                </FormRow>
                <FormRow
                  num='12.'
                  label='Whether the pupil has been declared eligible by the Board of Intermediate Education for University courses of study'
                >
                  <SelectField
                    name='eligible'
                    options={booleanValues}
                    placeholder='Select Value'
                  />
                </FormRow>
                <FormRow
                  num='13.'
                  label='(a) Whether the pupil was in receipt of any scholarship? (Nature of the scholarship to be specified)'
                >
                  <SelectField
                    name='scholarship'
                    options={booleanValues}
                    placeholder='Select Value'
                  />
                </FormRow>
                <FormRow
                  num=''
                  label='(b) Whether pupil was in receipt of any concession'
                  name='concession'
                >
                  {' '}
                  <SelectField
                    name='concession'
                    options={booleanValues}
                    placeholder='Select Value'
                  />
                </FormRow>
                <FormRow
                  num='14.'
                  label='Personal Marks of Identification (AS PERs SSC)'
                >
                  <div>
                    <div className='flex items-start gap-4'>
                      <div>1.</div>
                      <div className='w-full '>
                        <InputField name='mole1' />
                      </div>
                    </div>
                    <div className='flex items-start gap-4 mt-4'>
                      <div>2.</div>
                      <div className='w-full'>
                        <InputField name='mole2' />
                      </div>
                    </div>
                  </div>
                </FormRow>
                <FormRow
                  num='15.'
                  label='Date on which the pupil has actually left the College'
                  name='leavingDate'
                >
                  <DateField name='leavingDate' />
                </FormRow>
                <FormRow
                  num='16.'
                  label='Date of Transfer Certificate'
                  name='tcDate'
                >
                  {' '}
                  <DateField name='tcDate' />
                </FormRow>
                <FormRow num='17.' label='Conduct' name='conduct'>
                  <SelectField
                    name='conduct'
                    options={conductValues}
                    placeholder='Select Conduct'
                  />
                </FormRow>
                <FormRow
                  num='18.'
                  label='Signature of Head the Institution'
                  name='signature'
                >
                  <InputField name='signature' />
                </FormRow>
              </div>{' '}
              <div className='flex justify-between gap-12 mt-6'>
                {' '}
                <Button
                  variant='contained'
                  color='error'
                  type='button'
                  disabled={!values.tcNumber || isDownloading}
                  onClick={downloadTC}
                >
                  Print/Download
                </Button>
                <Button
                  variant='contained'
                  type='submit'
                  disabled={isIdExists || isSubmitting}
                >
                  Submit
                </Button>
              </div>
            </div>{' '}
          </Form>
        )}
      </Formik>
      <ToastNotification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        title={notification.title}
        severity={notification.severity}
        autoHideDuration={notification.autoHideDuration}
        position={notification.position}
      />
    </div>
  );
}

/* FORM FIELD ROW */
function FormRow({ num, label, children }) {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 '>
      <div className='flex items-start gap-4'>
        <div className='w-6'>{num}</div>
        <Typography variant='body1' className='w-[420px]'>
          {label}
        </Typography>
      </div>
      <div className='flex items-start gap-4'>
        <div className='px-1'>:</div>
        <div className='flex-1 ml-4'>{children}</div>
      </div>
    </div>
  );
}
const booleanValues = [
  { label: 'YES', value: true },
  { label: 'NO', value: false },
];
const conductValues = [
  { label: 'Excellent', value: 'Excellent' },
  { label: 'Good', value: 'Good' },
  { label: 'Average', value: 'Average' },
  { label: 'Bad', value: 'Bad' },
];
function InputField({ name, disabled = false, ...props }) {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <TextField
          {...props}
          size='small'
          disabled={disabled}
          variant='standard'
          {...field} // Spreads name, value, onChange, and onBlur
          fullWidth
          // Error handling:
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
        />
      )}
    </Field>
  );
}
function DateField({ name, disabled = false }) {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <TextField
          disabled={disabled}
          type='date'
          size='small'
          variant='standard'
          {...field} // Spreads name, value, onChange, and onBlur
          fullWidth
          // Error handling:
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
        />
      )}
    </Field>
  );
}
function SelectField({ name = '', options = [], placeholder = '' }) {
  return (
    <Field name={name}>
      {({ field, meta }) => {
        const isError = meta.touched && Boolean(meta.error);

        return (
          <FormControl fullWidth error={isError} variant='standard'>
            <Select
              {...field}
              size='small'

              // This renders the placeholder when the value is empty
              // renderValue={(value) => {
              //   if (!value || value.length === 0) {
              //     return <span style={{ color: '#aaa' }}>{placeholder}</span>;
              //   }
              //   // Find and show the label for the selected value
              //   // return options.find((opt) => opt.value === value)?.label;
              // }}
            >
              {/* Optional: Disabled placeholder item in the dropdown list */}
              <MenuItem value=''>
                <em>{placeholder}</em>
              </MenuItem>

              {options.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>

            {/* Error message appears here */}
            {isError && <FormHelperText>{meta.error}</FormHelperText>}
          </FormControl>
        );
      }}
    </Field>
  );
}
